export enum HeadWorkingType {
    Standard = 0,
    MitterInside = 1,
    MitterOutside = 2
}